var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPytorch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_3681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.995 7.81688L17.2128 9.59913C20.1392 12.5256 20.1392 17.2343 17.2128 20.1167C14.2864 23.0431 9.57767 23.0431 6.69525 20.1167C3.76882 17.1902 3.76882 12.4816 6.69525 9.59913L11.998 4.29637V0.797852L5.001 7.79488C1.10644 11.6894 1.10644 17.9824 5.001 21.8769C8.89557 25.7715 15.1885 25.7715 19.017 21.8769C22.8896 17.9824 22.8896 11.7334 18.995 7.81688Z",
    fill: "#EE4C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4965 7.39881C16.2135 7.39881 16.7947 6.81761 16.7947 6.10064C16.7947 5.38367 16.2135 4.80245 15.4965 4.80245C14.7796 4.80245 14.1983 5.38367 14.1983 6.10064C14.1983 6.81761 14.7796 7.39881 15.4965 7.39881Z",
    fill: "#EE4C2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_3681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.797852)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPytorch);
export default __webpack_public_path__ + "static/media/Pytorch.9e3f0fa2cafc36e66f89bcea7a0155e7.svg";
export { ForwardRef as ReactComponent };